import React, { useState, useEffect ,useRef} from "react";
import emailjs from "@emailjs/browser";

import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import ERPChatbot from "../../components/ERPChatbot/ERPChatbot";
import "./Careers.css";

export default function Careers() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const jobs = [
    { title: "Frontend Developer", department: "Engineering", location: "Remote", type: "Full-time", description: "Work with React, modern UI frameworks, and build scalable interfaces." },
    { title: "Backend Engineer", department: "Engineering", location: "Bangalore", type: "Full-time", description: "Design APIs, manage databases, and ensure system scalability." },
    { title: "Erp Functional Consultant", department: "Engineering", location: "Chennai", type: "Full-time", description: "Responsible for analyzing business processes, configuring ERP modules, and ensuring seamless system implementation and user adoption." },
    { title: "UI/UX Designer", department: "Design", location: "Remote", type: "Contract", description: "Create intuitive experiences and pixel-perfect designs." },
    { title: "HR Specialist", department: "HR", location: "Chennai", type: "Full-time", description: "Drive recruitment, employee engagement, and growth initiatives." },
  ];

  const [activeDept, setActiveDept] = useState("All");
  const applicationRef = useRef(null);
const nameInputRef = useRef(null);

  const [expandedJob, setExpandedJob] = useState(null);
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [statusMessage, setStatusMessage] = useState(""); // ✅ For success/error line

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    position: "",
    message: "",
    resume: null,
  });

  const filteredJobs =
    activeDept === "All"
      ? jobs
      : jobs.filter((job) => job.department === activeDept);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "resume") {
      setFormData({ ...formData, resume: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  // ✅ Validation
  const validateForm = () => {
    if (!formData.name || !formData.email || !formData.position) {
      setStatusMessage("⚠️ Please fill all required fields.");
      return false;
    }
    if (!/\S+@\S+\.\S+/.test(formData.email)) {
      setStatusMessage("⚠️ Please enter a valid email.");
      return false;
    }
    if (!formData.resume) {
      setStatusMessage("⚠️ Please upload your resume.");
      return false;
    }
    setStatusMessage("");
    return true;
  };

  // ✅ EmailJS submit
  const handleSubmit = (e) => {
    e.preventDefault();

    if (!validateForm()) return; // stop if validation fails

    setLoading(true);

    const reader = new FileReader();
    reader.readAsDataURL(formData.resume);

    reader.onload = () => {
      const base64Resume = reader.result.split(",")[1];

      const templateParams = {
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        position: formData.position,
        message: formData.message,
        resume: base64Resume,
      };

      emailjs
        .send(
          "service_aikb6s9", 
          "template_39b6bul", 
          templateParams,
          // "DTg29tM0_5_m0RPQc" 
        )
        .then(
          () => {
            setStatusMessage("✅ Application Submitted Successfully!");
            setStep(1);
            setFormData({
              name: "",
              email: "",
              phone: "",
              position: "",
              message: "",
              resume: null,
            });
            setLoading(false);
          },
          (error) => {
            console.error("❌ Error sending email:", error.text);
            setStatusMessage("❌ Failed to send application. Please try again.");
            setLoading(false);
          }
        );
    };

    reader.onerror = () => {
      setStatusMessage("❌ Error reading file. Please try again.");
      setLoading(false);
    };
  };

  return (
    <div className="careers-page">
      <Header />

      {/* Hero */}
      <section className="hero-career">
        <div className="career-overlay">
          <h1>Join Our Team</h1>
          <p>We’re building the future of ERP. Be a part of it.</p>
        </div>
      </section>

      {/* Career Journey */}
      <section className="journey">
        <h2>Your Career Path With Us</h2>
        <div className="timeline">
          <div className="timeline-step"><span>1</span><h3>Apply</h3><p>Submit your application easily through our portal.</p></div>
          <div className="timeline-step"><span>2</span><h3>Interview</h3><p>Collaborative interviews to know you better.</p></div>
          <div className="timeline-step"><span>3</span><h3>Offer</h3><p>Clear and quick hiring process with competitive offers.</p></div>
          <div className="timeline-step"><span>4</span><h3>Onboarding</h3><p>Seamless onboarding to set you up for success.</p></div>
        </div>
      </section>

      {/* Jobs */}
      <section className="jobs">
        <h2>Open Positions</h2>
        <div className="filters">
          {["All", "Engineering", "Design", "HR"].map((dept) => (
            <button
              key={dept}
              className={activeDept === dept ? "active" : ""}
              onClick={() => setActiveDept(dept)}
            >
              {dept}
            </button>
          ))}
        </div>
        <div className="job-list">
          {filteredJobs.map((job, i) => (
            <div key={i} className="job-card">
              <h3>{job.title}</h3>
              <p>{job.department} • {job.location} • {job.type}</p>
              <button onClick={() => setExpandedJob(expandedJob === i ? null : i)}>
                {expandedJob === i ? "Hide Details" : "View Details"}
              </button>
              {expandedJob === i && (
                <div className="job-details">
                  <p>{job.description}</p>
                  <button
                    className="apply-btn"
                    onClick={() => {
                      setFormData({ ...formData, position: job.title });
                      // Smooth scroll to form
                      applicationRef.current?.scrollIntoView({ behavior: "smooth" });
                      // Focus after scroll animation
                      setTimeout(() => {
                        nameInputRef.current?.focus();
                      }, 700);
                    }}
                  >
                    Apply Now
                  </button>

                </div>
              )}
            </div>
          ))}
        </div>
      </section>

      {/* Perks */} <section className="perks"> <h2>Perks & Benefits</h2> <div className="perks-grid"> <div className="perk"><span>🌍</span><p>Global Team</p></div> <div className="perk"><span>🧑‍💻</span><p>Latest Tech</p></div> <div className="perk"><span>🏖</span><p>Paid Leaves</p></div> <div className="perk"><span>📈</span><p>Growth Plans</p></div> <div className="perk"><span>💼</span><p>Health Insurance</p></div> <div className="perk"><span>🎉</span><p>Team Retreats</p></div> </div> </section>

      {/* Application Form */}
      <section className="application" id="application-form" ref={applicationRef}>
        <h2>Apply Now</h2>
        <p className="step-indicator">Step {step} of 3</p>
        <form className="application-form" onSubmit={handleSubmit}>
          <div className="progress">
            <div className="progress-bar" style={{ width: `${(step / 3) * 100}%` }}></div>
          </div>

          {step === 1 && (
            <div className="form-step">
              <input ref={nameInputRef} type="text" name="name" placeholder="Your Name" value={formData.name} onChange={handleChange} required />
              <input type="email" name="email" placeholder="Your Email" value={formData.email} onChange={handleChange} required />
              <input type="tel" name="phone" placeholder="Phone Number" value={formData.phone} onChange={handleChange}  required />
              <button type="button" onClick={() => setStep(2)}>Next</button>
            </div>
          )}

          {step === 2 && (
            <div className="form-step">
              <select name="position" value={formData.position} onChange={handleChange} required>
                <option value="">Select Position</option>
                {jobs.map((job, i) => (
                  <option key={i} value={job.title}>{job.title}</option>
                ))}
              </select>
              <textarea name="message" placeholder="Cover Letter / Message" value={formData.message} onChange={handleChange}></textarea>
              <label className="file-upload">
                <input type="file" name="resume" accept=".pdf,.doc,.docx" onChange={handleChange} hidden />
                <strong>📎 Upload Resume</strong>
                <span>PDF, DOC, DOCX (Max 5MB)</span>
                {formData.resume && <p className="file-name">Selected: {formData.resume.name}</p>}
              </label>

              <div className="step-buttons">
                <button type="button" onClick={() => setStep(1)}>Back</button>
                <button type="button" onClick={() => setStep(3)}>Next</button>
              </div>
            </div>
          )}

          {step === 3 && (
            <div className="form-step review">
              <h3>Review Your Application</h3>
              <p><b>Name:</b> {formData.name}</p>
              <p><b>Email:</b> {formData.email}</p>
              <p><b>Position:</b> {formData.position}</p>
              <div className="step-buttons">
                <button type="button" onClick={() => setStep(2)}>Back</button>
                <button type="submit" disabled={loading}>
                  {loading ? "Submitting..." : "Submit Application"}
                </button>
              </div>
            </div>
          )}

          {/* ✅ Message line like Contact Us */}
          {statusMessage && <p className="form-status">{statusMessage}</p>}
        </form>
      </section>

      <Footer />
      <ERPChatbot />
    </div>
  );
}
